import { render, staticRenderFns } from "./DialogAddVerdict.vue?vue&type=template&id=194ed990"
import script from "./DialogAddVerdict.vue?vue&type=script&lang=js"
export * from "./DialogAddVerdict.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('194ed990')) {
      api.createRecord('194ed990', component.options)
    } else {
      api.reload('194ed990', component.options)
    }
    module.hot.accept("./DialogAddVerdict.vue?vue&type=template&id=194ed990", function () {
      api.rerender('194ed990', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogAddVerdict.vue"
export default component.exports